/* ==========================================================================
   Happy Tea Time — theme.js
   Ingen afhængigheder. Alt er progressive enhancement.
   ========================================================================== */

(function () {
  'use strict';

  const routes = (window.theme && window.theme.routes) || {};
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  /* ------------------------------------------------------------------------
     Hjælpere
     ------------------------------------------------------------------------ */

  function formatMoney(cents) {
    const format = (window.theme && window.theme.moneyFormat) || '{{amount}} kr';
    const value = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function lockScroll(locked) {
    document.body.classList.toggle('is-locked', locked);
  }

  const scrim = $('[data-scrim]');
  let openLayer = null;

  function showScrim(show) {
    if (!scrim) return;
    if (show) {
      scrim.hidden = false;
      requestAnimationFrame(() => scrim.classList.add('is-visible'));
    } else {
      scrim.classList.remove('is-visible');
      setTimeout(() => {
        if (!scrim.classList.contains('is-visible')) scrim.hidden = true;
      }, 300);
    }
  }

  function closeLayer() {
    if (!openLayer) return;
    openLayer.classList.remove('is-open');
    openLayer.setAttribute('aria-hidden', 'true');
    openLayer = null;
    showScrim(false);
    lockScroll(false);
  }

  function openAsLayer(el) {
    if (!el) return;
    if (openLayer && openLayer !== el) closeLayer();
    openLayer = el;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    showScrim(true);
    lockScroll(true);
    const focusable = el.querySelector('[autofocus], button, a, input');
    if (focusable) setTimeout(() => focusable.focus(), 60);
  }

  if (scrim) scrim.addEventListener('click', closeLayer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeLayer();
      const search = $('[data-search-panel]');
      if (search && search.classList.contains('is-open')) {
        search.classList.remove('is-open');
      }
    }
  });

  /* ------------------------------------------------------------------------
     Mobilmenu
     ------------------------------------------------------------------------ */

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-menu-open]');
    if (openBtn) {
      e.preventDefault();
      openAsLayer($('[data-mobile-nav]'));
      return;
    }

    if (e.target.closest('[data-layer-close]')) {
      e.preventDefault();
      closeLayer();
      return;
    }

    const subToggle = e.target.closest('[data-sub-toggle]');
    if (subToggle) {
      e.preventDefault();
      const panel = subToggle.nextElementSibling;
      if (panel) {
        const open = panel.classList.toggle('is-open');
        subToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
  });

  /* ------------------------------------------------------------------------
     Desktop-dropdowns
     ------------------------------------------------------------------------ */

  $$('[data-nav-item]').forEach((item) => {
    const toggle = $('[data-nav-toggle]', item);
    if (!toggle) return;

    const open = (state) => {
      item.classList.toggle('is-open', state);
      toggle.setAttribute('aria-expanded', state ? 'true' : 'false');
    };

    item.addEventListener('mouseenter', () => open(true));
    item.addEventListener('mouseleave', () => open(false));
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      open(!item.classList.contains('is-open'));
    });
    item.addEventListener('focusout', (e) => {
      if (!item.contains(e.relatedTarget)) open(false);
    });
  });

  /* ------------------------------------------------------------------------
     Søgepanel
     ------------------------------------------------------------------------ */

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-search-toggle]');
    if (!trigger) return;
    e.preventDefault();
    const panel = $('[data-search-panel]');
    if (!panel) return;
    const isOpen = panel.classList.toggle('is-open');
    if (isOpen) {
      const input = $('input[type="search"]', panel);
      if (input) setTimeout(() => input.focus(), 80);
    }
  });

  /* ------------------------------------------------------------------------
     Antalsvælger
     ------------------------------------------------------------------------ */

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const wrap = btn.closest('[data-qty]');
    const input = $('input', wrap);
    if (!input) return;
    const step = btn.dataset.qtyChange === 'up' ? 1 : -1;
    const min = parseInt(input.min || '1', 10);
    const next = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------------------
     Harmonika
     ------------------------------------------------------------------------ */

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;
    const item = trigger.closest('[data-accordion-item]');
    if (!item) return;
    const open = item.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ------------------------------------------------------------------------
     Karrusel (rail)
     ------------------------------------------------------------------------ */

  $$('[data-carousel]').forEach((root) => {
    const rail = $('[data-rail]', root);
    const prev = $('[data-rail-prev]', root);
    const next = $('[data-rail-next]', root);
    if (!rail || !prev || !next) return;

    const step = () => {
      const first = rail.firstElementChild;
      if (!first) return rail.clientWidth * 0.8;
      const gap = parseFloat(getComputedStyle(rail).columnGap || '16') || 16;
      return first.getBoundingClientRect().width + gap;
    };

    const sync = () => {
      prev.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    };

    prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ------------------------------------------------------------------------
     Anmeldelses-karrusel (skifter grupper)
     ------------------------------------------------------------------------ */

  $$('[data-quote-carousel]').forEach((root) => {
    const groups = $$('[data-quote-group]', root);
    if (groups.length < 2) return;
    let index = 0;

    const render = () => {
      groups.forEach((g, i) => {
        g.hidden = i !== index;
      });
    };

    $$('[data-quote-prev]', root).forEach((b) =>
      b.addEventListener('click', () => {
        index = (index - 1 + groups.length) % groups.length;
        render();
      })
    );
    $$('[data-quote-next]', root).forEach((b) =>
      b.addEventListener('click', () => {
        index = (index + 1) % groups.length;
        render();
      })
    );

    render();
  });

  /* ------------------------------------------------------------------------
     Roterende annoncebar
     ------------------------------------------------------------------------ */

  $$('[data-announcement-rotate]').forEach((root) => {
    const slides = $$('[data-announcement-slide]', root);
    if (slides.length < 2) return;
    const interval = parseInt(root.dataset.announcementRotate, 10) || 5;
    let i = 0;
    setInterval(() => {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, interval * 1000);
  });

  /* ------------------------------------------------------------------------
     Produktgalleri
     ------------------------------------------------------------------------ */

  // Paa mobil er galleriet et vandret swipe med miniaturer under.
  $$('[data-gallery]').forEach((root) => {
    const slides = $$('[data-gallery-slide]', root);
    if (slides.length < 2) return;

    const wrap = root.closest('.product__gallery');
    if (!wrap) return;

    const thumbs = $$('[data-gallery-thumb]', wrap);
    if (!thumbs.length) return;

    const bar = thumbs[0].parentElement;
    let current = -1;

    const setActive = (i, scrollBar) => {
      if (i === current) return;
      current = i;

      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));

      // Hold den aktive miniature synlig i raekken.
      if (scrollBar && bar) {
        const t = thumbs[i];
        const left = t.offsetLeft - bar.clientWidth / 2 + t.offsetWidth / 2;
        bar.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    };

    const sync = () => {
      const middle = root.scrollLeft + root.clientWidth / 2;
      let active = 0;
      slides.forEach((slide, i) => {
        if (slide.offsetLeft <= middle) active = i;
      });
      setActive(active, true);
    };

    thumbs.forEach((t, i) => {
      t.addEventListener('click', () => {
        root.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        setActive(i, false);
      });
    });

    root.addEventListener('scroll', sync, { passive: true });
    setActive(0, false);
  });

  /* ------------------------------------------------------------------------
     Video — klik for at afspille
     ------------------------------------------------------------------------ */

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-video-play]');
    if (!btn) return;

    const block = btn.closest('[data-video]');
    if (!block) return;

    const video = block.querySelector('video');
    if (!video) return;

    block.classList.add('is-playing');
    video.controls = true;
    const played = video.play();
    if (played && typeof played.catch === 'function') {
      played.catch(() => block.classList.remove('is-playing'));
    }
  });

  /* ------------------------------------------------------------------------
     Video-lightbox
     ------------------------------------------------------------------------ */

  function closeVideoModal(modal) {
    if (!modal) return;

    const video = modal.querySelector('video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }

    // Iframen tømmes, ellers spiller YouTube videre i baggrunden.
    const frame = modal.querySelector('iframe');
    if (frame) frame.removeAttribute('src');

    modal.classList.remove('is-open');
    lockScroll(false);
    setTimeout(() => {
      if (!modal.classList.contains('is-open')) modal.hidden = true;
    }, 300);
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-video-open]');
    if (opener) {
      const section = opener.closest('.shopify-section') || document;
      const modal = section.querySelector('[data-video-modal]');
      if (!modal) return;

      modal.hidden = false;
      requestAnimationFrame(() => modal.classList.add('is-open'));
      lockScroll(true);

      const frame = modal.querySelector('iframe');
      if (frame && frame.dataset.videoSrc) frame.src = frame.dataset.videoSrc;

      const video = modal.querySelector('video');
      if (video) {
        const played = video.play();
        if (played && typeof played.catch === 'function') played.catch(() => {});
      }

      const closeBtn = modal.querySelector('[data-video-close]');
      if (closeBtn) setTimeout(() => closeBtn.focus(), 60);
      return;
    }

    const closer = e.target.closest('[data-video-close]');
    if (closer) {
      closeVideoModal(closer.closest('[data-video-modal]'));
      return;
    }

    // Klik på den mørke baggrund lukker også.
    const modal = e.target.closest('[data-video-modal]');
    if (modal && !e.target.closest('.video-modal__inner')) {
      closeVideoModal(modal);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('[data-video-modal].is-open').forEach(closeVideoModal);
  });

  const isMobileGallery = () => window.matchMedia('(max-width: 900px)').matches;

  function selectMediaForVariant(variant) {
    if (!variant || !variant.featured_image) return;

    const root = $('[data-gallery]');
    if (!root) return;

    const slide = $$('[data-gallery-slide]', root).find(
      (s) => parseInt(s.dataset.mediaId, 10) === variant.featured_image.id
    );
    if (!slide) return;

    // Paa desktop ligger alle billeder synligt i mosaikken — der skal
    // siden ikke hoppe. Kun swipe-galleriet paa mobil rykkes.
    if (isMobileGallery()) {
      root.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }
  }

  /* ------------------------------------------------------------------------
     Variantvælger
     ------------------------------------------------------------------------ */

  $$('[data-variant-picker]').forEach((picker) => {
    const form = picker.closest('form') || $('[data-product-form]');
    const dataEl = $('[data-variant-json]', picker.closest('[data-product-root]') || document);
    if (!dataEl) return;

    let variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }

    const root = picker.closest('[data-product-root]') || document;
    const idInput = $('[data-variant-id]', root);
    const priceEl = $('[data-product-price]', root);
    const submitBtn = $('[data-add-to-cart]', root);
    const skuEl = $('[data-product-sku]', root);
    const stockEl = $('[data-product-stock]', root);

    function currentOptions() {
      const values = [];
      $$('[data-option-index]', picker).forEach((group) => {
        const checked = $('input:checked', group);
        if (checked) values[parseInt(group.dataset.optionIndex, 10)] = checked.value;
      });
      return values;
    }

    function matchVariant(values) {
      return variants.find((v) => v.options.every((opt, i) => opt === values[i]));
    }

    function render() {
      const values = currentOptions();
      const variant = matchVariant(values);

      $$('.option__value', picker).forEach((label) => {
        const input = $('input', label);
        label.classList.toggle('is-selected', input && input.checked);
      });

      if (!variant) {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = window.theme.strings.unavailable;
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (priceEl) {
        let html = '<span class="price__current">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<span class="price__compare">' + formatMoney(variant.compare_at_price) + '</span>';
          priceEl.classList.add('price--on-sale');
        } else {
          priceEl.classList.remove('price--on-sale');
        }
        priceEl.innerHTML = html;
      }

      if (skuEl) skuEl.textContent = variant.sku || '';

      if (stockEl) {
        if (!variant.available) stockEl.textContent = window.theme.strings.soldOut;
        else if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5)
          stockEl.textContent = stockEl.dataset.lowTemplate
            ? stockEl.dataset.lowTemplate.replace('__COUNT__', variant.inventory_quantity)
            : '';
        else stockEl.textContent = '';
      }

      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available
          ? window.theme.strings.addToCart
          : window.theme.strings.soldOut;
      }

      selectMediaForVariant(variant);

      if (history.replaceState && variant.id) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    picker.addEventListener('change', () => {
      render();
      renderCompanionCard(root);
    });
    render();
  });

  /* ------------------------------------------------------------------------
     Gratis underdel

     Nogle varianter har en underdel knyttet til sig via variant-metafeltet
     custom.gratis_underdel. Den skal i kurven sammen med kanden, uden at
     kunden skal huske det. Prisen bliver 0 af den automatiske BXGY-rabat i
     Shopify — temaet regner ikke selv priser ud.
     ------------------------------------------------------------------------ */

  // Liquids routes peger paa formular-endpointet (/cart/add). Ajax-API'et
  // ligger paa .js-varianten, og kun den forstaar en items-liste — uden
  // suffikset ryger underdelen lydloest paa gulvet.
  function ajaxUrl(base) {
    if (!base) return base;
    return base.indexOf('.js') === base.length - 3 ? base : base + '.js';
  }

  function companionMap(root) {
    const el = $('[data-companion-json]', root || document);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  // Underdelen der hører til den variant kunden har valgt lige nu.
  // Udsolgte underdele springes over — ellers ville hele kurv-kaldet fejle,
  // og kunden ville stå uden kande.
  function companionFor(scope) {
    const root = scope.closest('[data-product-root]') || document;
    const map = companionMap(root);
    if (!map) return null;
    const idInput = $('[data-variant-id]', root);
    if (!idInput) return null;
    const companion = map[idInput.value];
    if (!companion || !companion.available) return null;
    return companion;
  }

  // Kortet er allerede skrevet ud af Liquid for den foerste variant, saa det
  // staar der uden JS. Her opdateres kun felterne, naar kunden skifter
  // stoerrelse — billedet skal skifte med, ellers viser vi den forkerte
  // underdel.
  function renderCompanionCard(root) {
    const card = $('[data-companion-card]', root || document);
    if (!card) return;
    const companion = companionFor(card);
    if (!companion) {
      card.hidden = true;
      return;
    }

    const img = $('[data-companion-image]', card);
    if (img && companion.image) {
      img.src = companion.image;
      img.alt = companion.alt || companion.title;
    }

    const title = $('[data-companion-title]', card);
    if (title) title.textContent = companion.title;

    const variant = $('[data-companion-variant]', card);
    if (variant) {
      const hasVariant = companion.variant && companion.variant.indexOf('Default') === -1;
      variant.textContent = hasVariant ? companion.variant : '';
      variant.hidden = !hasVariant;
    }

    const was = $('[data-companion-was]', card);
    if (was) was.textContent = companion.price || '';

    card.hidden = false;
  }

  $$('[data-product-root]').forEach(renderCompanionCard);

  /* ------------------------------------------------------------------------
     Kurv
     ------------------------------------------------------------------------ */

  async function refreshCartDrawer() {
    const drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    try {
      const res = await fetch(routes.cart_url + '?section_id=cart-drawer');
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const fresh = html.querySelector('[data-cart-drawer]');
      if (fresh) drawer.innerHTML = fresh.innerHTML;
    } catch (err) {
      /* stille fejl — kurven kan stadig tilgås på /cart */
    }
    await refreshCartCount();
  }

  async function refreshCartCount() {
    try {
      const res = await fetch(routes.cart_url + '.js');
      const cart = await res.json();
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    } catch (err) {
      /* ignoreres */
    }
  }

  // Oversaet formularen til et linjeobjekt, saa kanden og underdelen kan
  // sendes i samme /cart/add.js-kald. Egenskaber og abonnement skal med,
  // ellers taber vi felter som formularen selv ville have sendt.
  function lineFromForm(form) {
    const data = new FormData(form);
    const line = {
      id: Number(data.get('id')),
      quantity: parseInt(data.get('quantity'), 10) || 1
    };

    const properties = {};
    data.forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    });
    if (Object.keys(properties).length) line.properties = properties;

    const plan = data.get('selling_plan');
    if (plan) line.selling_plan = Number(plan);

    return line;
  }

  // Tilføj til kurv
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;

    const drawer = window.theme.cartType === 'drawer';
    const companion = companionFor(form);
    // Uden skuffe og uden underdel er der intet at overtage — lad
    // browseren sende formularen som den plejer.
    if (!drawer && !companion) return;

    e.preventDefault();
    const btn = $('[data-add-to-cart]', form);
    const original = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = '…';
    }

    try {
      let body;
      const headers = { Accept: 'application/javascript' };

      if (companion) {
        const line = lineFromForm(form);
        body = JSON.stringify({
          items: [line, { id: companion.id, quantity: line.quantity }]
        });
        headers['Content-Type'] = 'application/json';
      } else {
        body = new FormData(form);
      }

      const res = await fetch(companion ? ajaxUrl(routes.cart_add_url) : routes.cart_add_url, {
        method: 'POST',
        headers: headers,
        body: body
      });

      if (!res.ok) throw new Error('add failed');

      if (drawer) {
        await refreshCartDrawer();
        openAsLayer($('[data-cart-drawer]'));
      } else {
        window.location.href = routes.cart_url;
        return;
      }
    } catch (err) {
      // Sidste udvej: den almindelige formular. Den lægger kun kanden i
      // kurven, men det er bedre end en knap der ikke gør noget.
      form.submit();
      return;
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.textContent = original;
      }
    }
  });

  // Åbn kurv
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-cart-open]');
    if (!trigger) return;
    if (window.theme.cartType !== 'drawer') return;
    e.preventDefault();
    openAsLayer($('[data-cart-drawer]'));
  });

  // Ændr linje
  async function changeLine(line, quantity) {
    try {
      const res = await fetch(ajaxUrl(routes.cart_change_url), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      });
      if (!res.ok) throw new Error('change failed');
      await refreshCartDrawer();
      if (document.body.classList.contains('template-cart')) window.location.reload();
    } catch (err) {
      window.location.href = routes.cart_url;
    }
  }

  document.addEventListener('click', (e) => {
    const remove = e.target.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(parseInt(remove.dataset.lineRemove, 10), 0);
    }
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (!input) return;
    changeLine(parseInt(input.dataset.lineQty, 10), parseInt(input.value, 10) || 0);
  });

  /* ------------------------------------------------------------------------
     Kort med i pakken (gave)
     ------------------------------------------------------------------------ */

  // Felterne ligger i formularen til betaling, saa de virker ogsaa uden
  // JavaScript. Med JavaScript gemmer vi dem med det samme, ellers ville
  // fluebenet forsvinde naeste gang skuffen tegnes forfra efter en aendring.
  async function saveCartAttributes(attributes) {
    const res = await fetch(ajaxUrl(routes.cart_update_url), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes })
    });
    if (!res.ok) throw new Error('attributes failed');
  }

  // Skuffen og kurvesiden vises samtidig paa /cart. Skifter kunden i den ene,
  // skal den anden foelge med, ellers staar der to forskellige svar paa skaermen.
  function syncGiftWrap(checked, source) {
    $$('[data-gift-wrap]').forEach((wrap) => {
      const box = $('[data-gift-toggle]', wrap);
      const fields = $('[data-gift-fields]', wrap);
      const message = $('[data-gift-message]', wrap);
      if (box && box !== source) box.checked = checked;
      if (fields) fields.hidden = !checked;
      // Slaaet fra sender feltet ikke noget med, saa et gammelt navn ikke
      // foelger med en ordre der ikke er en gave.
      if (message) message.disabled = !checked;
    });
  }

  document.addEventListener('change', async (e) => {
    const toggle = e.target.closest('[data-gift-toggle]');
    if (toggle) {
      const wanted = toggle.checked;
      syncGiftWrap(wanted, toggle);
      if (!wanted) $$('[data-gift-message]').forEach((el) => { el.value = ''; });
      try {
        await saveCartAttributes(
          wanted ? { Gave: 'Ja' } : { Gave: '', Gavemodtager: '' }
        );
      } catch (err) {
        syncGiftWrap(!wanted, null);
      }
      return;
    }

    const message = e.target.closest('[data-gift-message]');
    if (message) {
      $$('[data-gift-message]').forEach((el) => {
        if (el !== message) el.value = message.value;
      });
      try {
        await saveCartAttributes({ Gavemodtager: message.value });
      } catch (err) {
        /* stille fejl — feltet foelger stadig med formularen til betaling */
      }
    }
  });

  /* ------------------------------------------------------------------------
     Reveal ved scroll
     ------------------------------------------------------------------------ */

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    $$('.reveal').forEach((el) => io.observe(el));
  } else {
    $$('.reveal').forEach((el) => el.classList.add('is-visible'));
  }

  /* ------------------------------------------------------------------------
     Headerhøjde som CSS-variabel
     ------------------------------------------------------------------------ */

  function syncHeaderHeight() {
    const header = $('[data-header]');
    if (!header) return;
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }

  window.addEventListener('load', syncHeaderHeight);
  window.addEventListener('resize', syncHeaderHeight);
  syncHeaderHeight();

  /* ------------------------------------------------------------------------
     Shopify theme editor
     ------------------------------------------------------------------------ */

  document.addEventListener('shopify:section:load', () => {
    syncHeaderHeight();
    $$('.reveal').forEach((el) => el.classList.add('is-visible'));
  });
})();
